<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left active">
      <div v-if="isVertical">
        <router-link v-if="user?.roles[0] === 'super_admin'" to="/companies/companies-list" class="logo logo-normal">
          <img :src="logoSrc" alt="Logo" class="img-fluid" />
        </router-link>
        <router-link v-else to="/dashboard/deals-dashboard" class="logo logo-normal">
          <img :src="logoSrc" alt="Logo" class="img-fluid" />
        </router-link>
      </div>
      <div v-else>
        <router-link v-if="user?.roles[0] === 'super_admin'" to="/companies/companies-list"
          class="logo-small d-flex align-items-center justify-content-between">
          <img :src="logoSrc" alt="Logo" class="img-fluid" />
          <div class="horizontal-user-name">
            <h5>{{ user.first_name }} {{ user.last_name }}</h5>
            <h6>{{ user.company_name }}</h6>
          </div>
        </router-link>
        <router-link v-else to="/dashboard/deals-dashboard"
          class="logo-small d-flex align-items-center justify-content-between">
          <img :src="logoSrc" alt="Logo" class="img-fluid" />
          <div class="horizontal-user-name">
            <h5>{{ user.first_name }} {{ user.last_name }}</h5>
            <h6>{{ user.company_name }}</h6>
          </div>
        </router-link>
      </div>
      <a id="toggle_btn" @click="toggleValue" href="javascript:void(0);">
        <i class="ti ti-arrow-bar-to-left"></i>
      </a>
    </div>
    <!-- /Logo -->

    <a id="mobile_btn" class="mobile_btn" href="#sidebar" @click="toggleSidebar1">
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a>
    <div class="header-user">
      <ul class="nav user-menu px-3 justify-content-between row mx-0">
        <div v-if="!isVertical" class="sidebar-horizontal col-md-5" id="horizontal-single">
          <horizontal-sidebar></horizontal-sidebar>
        </div>
        <div v-else class="sidebar-horizontal col-md-5" id="horizontal-single">

        </div>
        <!-- Search -->
        <div class="col-md-7 col-lg-7 d-flex justify-content-end align-items-center pe-0">
          <li class="nav-item nav-search-inputs flex-1 w-100" v-if="user?.roles[0] !== 'super_admin'">
            <global-search></global-search>
          </li>
          <li class="nav-item nav-search-inputs" v-else>

          </li>

          <!-- <li class="nav-item nav-list">
            <ul class="nav">
              <li class="dark-mode-list">
                <a href="javascript:void(0);" id="dark-mode-toggle" class="dark-mode-toggle" @click="toggleDarkMode">
                  <i class="ti ti-sun light-mode" :class="{ active: isLightMode }"></i>
                  <i class="ti ti-moon dark-mode" :class="{ active: !isLightMode }"></i>
                </a>
              </li>
            </ul>
          </li> -->
          <!-- Notifications -->
          <li class="nav-item dropdown nav-item-box" v-if="user?.roles[0] !== 'super_admin'">
            <a href="javascript:void(0);" class="nav-link" data-bs-toggle="dropdown" @click="markReadNotifications">
              <i class="ti ti-bell"></i>
              <span v-if="totalNotification.totalReadNotifications" class="badge rounded-pill">{{
                totalNotification.totalReadNotifications }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-end notification-dropdown notification">
              <div class="topnav-dropdown-header">
                <h4 class="notification-title">Notifications</h4>
              </div>
              <div class="noti-content" @scroll="onScroll">
                <ul class="notification-list">
                  <li class="notification-message" v-for="notification in notificationData">
                    <div class="media d-flex">
                      <div class="media-body flex-grow-1 m-2">
                        <router-link :to="notification.module_type === 'opportunities'
                          ? `/crm/meter-opportunities-edit/${notification.module_id}`
                          : `/crm/edit-contract/${notification.module_id}`">
                          <p class="noti-details">
                            {{ notification.message }}
                          </p>
                          <p class="noti-time">{{ notification.notify_time }}</p>
                        </router-link>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- /Notifications -->

          <!-- Profile Dropdown -->
          <li class="nav-item dropdown has-arrow main-drop">
            <a href="javascript:void(0);" class="nav-link userset p-0" data-bs-toggle="dropdown">
              <span class="user-info position-relative">
                <span class="user-letter">
                  <img v-if="user.image" :src="user.image" class="img-fluid" alt="Profile" />
                  <img v-else src='@/assets/img/profiles/avatar-20.jpg' class="img-fluid" alt="Profile" />
                </span>
                <div class="position-absolute bottom-0 end-0 bg-white rounded-circle active-wrap d-flex align-items-center justify-content-center">
                  <span class="badge badge-success rounded-circle "></span>
                </div>
              </span>
            </a>
            <div class="dropdown-menu menu-drop-user">
              <div class="profilename">
                <router-link v-if="Object.keys(user).length && user.permissions.includes('Dashboard')"
                  class="dropdown-item" to="/dashboard/">
                  <i class="ti ti-layout-2"></i> Dashboard
                </router-link>
                <router-link
                  v-if="user?.permissions?.includes('General Settings' || 'Data Import' || 'Users' || 'Territories')"
                  class="dropdown-item" to="/settings/profile">
                  <i class="ti ti-user-pin"></i> Configurations
                </router-link>
                <button class="dropdown-item" @click.prevent="handleLogout">
                  <i class="ti ti-lock"></i> Logout
                </button>
              </div>
            </div>
          </li>

        </div>
        <!-- /Search -->

        <!-- /Profile Dropdown -->
      </ul>
    </div>

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
      <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i
          class="fa fa-ellipsis-v"></i></a>
      <div class="dropdown-menu">
        <router-link class="dropdown-item" to="/dashboard/">
          <i class="ti ti-layout-2"></i> Dashboard
        </router-link>
        <router-link class="dropdown-item" to="/settings/profile">
          <i class="ti ti-user-pin"></i> My Profile
        </router-link>
        <router-link class="dropdown-item" to="/">
          <i class="ti ti-lock"></i> Logout
        </router-link>
      </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->

  <!-- <side-settings></side-settings> -->
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { mapGetters, mapActions } from 'vuex';
import { computed, ref, watch } from "vue";
export default {
  data() {
    return {
      isLightMode: true,
      // isVertical: JSON.parse(localStorage.getItem('isVertical')) ?? true,
    };
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const isVertical = computed(() => store.getters["changelayout/getHeader"]);

    const notificationData = computed(() => store.getters["users/getNotifications"]);
    const totalNotification = computed(() => store.getters["users/getTotalNotifications"]);
    const isFetching = ref(false);

    const company_image = ref(JSON.parse(localStorage.getItem('user')).company_logo)

    // const user = ref(JSON.parse(localStorage.getItem('user')) || {});

    const user = computed(() => {
      const user = store.getters['auth/user']
      return user;
    })

    // --- Make dark mode reactive ---
    const isDarkMode = ref(localStorage.getItem("darkMode") === "enabled");
    
    const logoSrc = computed(() => {
      if (isDarkMode.value) {
        return require('@/assets/img/img-white.png');
      }
      const companyLogo = store.getters['auth/company_logo'] || company_image.value;
      return companyLogo ? `${companyLogo}?v=${new Date().getTime()}` : require('@/assets/img/icrmLogo.png');
    });
    // --- End logoSrc ---

    const toggleValue = async () => {
      store.dispatch("changelayout/toggleHeader", 'fromButton'); // Replace 'yourModule' with your actual module name
    };
    // Logout function
    const handleLogout = async () => {
      try {
        await store.dispatch('auth/logout');
        await store.commit('users/SET_NOTIFICATIONS', [])
        await store.dispatch('importMessage', { status: false, message: null })
        // router.push('/');
      } catch (error) {
        console.error('Logout failed:', error);
      }
    };

    const getNotifications = async () => {
      try {
        if (isFetching.value) return;
        isFetching.value = true;
        let count = notificationData.value.length;
        if (count >= 10 && totalNotification.value.totalNotifications > count) {
          const current_page = Math.ceil(count / 10) + 1;
          const params = {
            page: current_page
          };
          await store.dispatch('users/fetchNotifications', params)
          return;
        }
      } catch (error) {

      }
      finally {
        isFetching.value = false;
      }
    }

    const onScroll = async (event) => {
      const element = event.target;
      if (element.scrollTop + element.clientHeight >= element.scrollHeight - 3 && !isFetching.value) {
        getNotifications()
      }
    };

    const markReadNotifications = async () => {
      if (totalNotification.value.totalReadNotifications) {
        await store.dispatch('users/markReadNotifications')
      }
    }

    // --- Update isDarkMode in dark mode methods ---
    const enableDarkMode = () => {
      document.documentElement.setAttribute("data-theme", "dark");
      isDarkMode.value = true;
      localStorage.setItem("darkMode", "enabled");
      // this.isLightMode = false; // not needed in setup
    };
    const disableDarkMode = () => {
      document.documentElement.setAttribute("data-theme", "light");
      isDarkMode.value = false;
      localStorage.removeItem("darkMode");
      // this.isLightMode = true; // not needed in setup
    };
    const toggleDarkMode = () => {
      if (!isDarkMode.value) {
        enableDarkMode();
      } else {
        disableDarkMode();
      }
    };
    const initializeDarkMode = () => {
      // if (localStorage.getItem("darkMode") === "enabled") {
      //   enableDarkMode();
      // } else {
      //   disableDarkMode();
      // }
      disableDarkMode();
    };
    // --- End update ---

    return {
      handleLogout,
      toggleValue,
      isVertical,
      user,
      company_image,
      notificationData,
      onScroll,
      isFetching,
      getNotifications,
      totalNotification,
      markReadNotifications,
      logoSrc,
      // expose dark mode toggles for template if needed
      toggleDarkMode,
      enableDarkMode,
      disableDarkMode,
      initializeDarkMode,
      isDarkMode,
    };
  },
  computed: {
    ...mapGetters('auth', ['company', 'company_logo', 'user']), // 'auth' is the namespace of your Vuex module

  },
  methods: {
    ...mapActions('auth', ['loadCompanyFromLocalStorage', 'loadUserFromLocalStorage']),
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
      this.isVertical = !this.isVertical
      localStorage.setItem('isVertical', JSON.stringify(this.isVertical));
    },
  },
  mounted() {
    this.loadCompanyFromLocalStorage();
    this.initializeDarkMode();
    localStorage.setItem('isVertical', JSON.stringify(this.isVertical));
    // this.initMouseoverListener();
    // const body = document.body;
    // if(this.isVertical && body.classList.contains('mini-sidebar')){
    //   body.classList.add('expand-menu');
    // }else{
    //   body.classList.toggle("mini-sidebar");
    // }
  },
  // beforeUnmount() {
  //   document.removeEventListener('mouseover', this.handleMouseover);
  // },
};
</script>
<style scoped lang="scss">
.logo-normal {
  img {
    max-height: 45px;
    object-fit: contain;
    // object-fit: cover;
    // margin-top: 10px;
  }
}

.title {
  padding-left: 6rem;
  font-weight: bold;
  color: #333;
}

.horizontal-user-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #F6F6F6;
  border-radius: 5px;
  margin: 10px;
  padding: 10px;
  height: 40px;
}

.horizontal-user-name h5 {
  color: #262A2A;
  font-size: 12px;
}

.horizontal-user-name h6 {
  color: #6F6F6F;
  font-size: 11px;
}

.notification {
  min-width: 450px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
}

.noti-content {
  max-height: 72vh;
  overflow: auto;
}

a:hover {

  .noti-details,
  p.noti-time {
    color: #E41F07;
    transition: all 0.5s ease;
  }
}
</style>